module.exports = __webpack_public_path__ + "static/media/chair.fd69ec7a.svg";